<app-go-back-button class="edit-go-back-btn" (click)="goBack()"></app-go-back-button>  

<section class="edit-email">
  <div class="top" #top>
    <h3><span class="regular" i18n="Title for the email edition form in My Space section@@EMAIL_MODIFICATION">Email</span> modification</h3>
  </div>

  @if(emailUpdated){
    <div class="success-message">
      <p i18n="Success message for the email edition form in My Space section@@EMAIL_CHANGE_OK">Your email has been successfully changed</p>
    </div>
  }

  <form [formGroup]="emailFormGroup" (ngSubmit)="onSubmit()">
    <div class="input-holder">
      <input
        id="login"
        type="text"
        placeholder="Login"
        autocapitalize="none"
        #inputLogin
        [value]="user?.email"
        formControlName="emailCtrl"
      />
    </div>

    <button
      class="submit"
      type="submit"
      [disabled]="emailFormGroup.invalid"
      i18n="Text for the button to validate the new email in the email edition form@@VALIDATE_NEW_EMAIL"
    >
      Validate new email
    </button>
  </form>
</section>
    